export const WORLD_LAYER_SATELLITE_MAP_TOGGLED =
  "WORLD_LAYER_SATELLITE_MAP_TOGGLED";
export const toggleSatelliteMap = (): IAction<null> => ({
  type: WORLD_LAYER_SATELLITE_MAP_TOGGLED,
});

export interface IWorldLayerState {
  satelliteLayerIsOn: boolean;
}
const defaultState: IWorldLayerState = {
  satelliteLayerIsOn: false,
};
export default function worldLayerReducer(
  state: IWorldLayerState = defaultState,
  action: IAction<any>,
): IWorldLayerState {
  switch (action.type) {
    case WORLD_LAYER_SATELLITE_MAP_TOGGLED:
      return {
        ...state,
        satelliteLayerIsOn: !state.satelliteLayerIsOn,
      };
    default:
      return state;
  }
}
